module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_3_3_5_cell600.e044d809.png";